export default class ElementPosition {
  static getElementCurrentTopPosition(element) {
    return element.getBoundingClientRect().top + window.scrollY;
  };

  static isElementOutOfBottom(element, gap = 0) {
    return element.getBoundingClientRect().bottom > (window.innerHeight - gap);
  };

  static isElementOutOfTop(element, gap = 0) {
    return element.getBoundingClientRect().top < gap;
  };

  static isElementOutOfLeft(element, gap = 0) {
    return element.getBoundingClientRect().left < gap;
  };

  static isElementOutOfRight(element, gap = 0) {
    return element.getBoundingClientRect().right > (window.innerWidth - gap);
  };

  static isElementOnScreen(element, gapParams = {}) {
    return {
      bottom: ElementPosition.isElementOutOfBottom(element, gapParams.bottom || 0),
      left: ElementPosition.isElementOutOfLeft(element, gapParams.left || 0),
      right: ElementPosition.isElementOutOfRight(element, gapParams.right || 0),
      top: ElementPosition.isElementOutOfTop(element, gapParams.top || 0),
    };
  };
}
